import React from 'react';
import TableHeaderCell from './tableHeaderCell';
import { TableHeaderDataProps, TableProps } from './table.interface';
import './table.scss';
import { CheckmarkCircleIcon, RemoveIcon } from '../icons/icons';
import Loader from '../loader/loader';

const Table = ({
    headerData,
    bodyData,
    customClass = '',
    hasCheckAllOption,
    handleCheckAll,
    totalChecked,
    sortIndex,
    activeColumn,
    pageDataLimit = 25,
    totalResults,
    message,
    setPageServerSide,
    activePage,
    isFiltering = false
}: TableProps) => {

    // Server Side Logic
    function changePageServerSide(event: React.ChangeEvent<HTMLSelectElement>): void {
        if (!setPageServerSide) return;
        const pageNumber = (Number(event.target.value));
        setPageServerSide(pageNumber);
    }

    function getTotalPagesOnServerSide(): number {
        if (!totalResults) return 0;
        const dividedServer = totalResults / pageDataLimit;
        const totalServerPages = totalResults % pageDataLimit == 0 ? dividedServer : Math.floor(dividedServer) + 1;
        return totalServerPages;
    }

    function selectPageOptions() {
        if (!totalResults) return;
        const totalPages = getTotalPagesOnServerSide();

        const results: any = []; // eslint-disable-line @typescript-eslint/no-explicit-any
        [...Array(totalPages)].map((item, index) => {
            const pageOption = index + 1;
            results.push(
                <option className="select-option"
                    key={pageOption}
                    value={pageOption}
                >
                    {pageOption}
                </option>
            );
        });

        return [...results];
    }

    function handleCheckAllClick(check: boolean) {
        if (handleCheckAll) {
            handleCheckAll(check);
        }
    }

    return (
        <div className={`table-grid ${customClass}`} data-testid="table">

            <div className="grid-wrapper-12 index-controls">
                <div className="grid-4 check-uncheck-all">
                    {hasCheckAllOption &&
                        <>
                            <a className="check-all" title={`Check All ${bodyData.length.toLocaleString()} Rows`} onClick={() => handleCheckAllClick(true)} data-testid="check-all">
                                <CheckmarkCircleIcon variant="check-all-icon" />
                                <span>Check All</span>
                            </a>
                            <a className="uncheck-all" title={`Uncheck All ${bodyData.length.toLocaleString()} Rows`} onClick={() => handleCheckAllClick(false)} data-testid="uncheck-all">
                                <RemoveIcon variant="uncheck-all-icon" />
                                <span>Uncheck All</span>
                            </a>
                        </>
                    }
                </div>

                <div className="grid-4 paginator">
                    <small>Page
                        <select className="page-select" onChange={changePageServerSide} role="select" value={activePage || 1} data-testid="server-side-page-select">
                            {selectPageOptions()}
                        </select>
                        of {getTotalPagesOnServerSide()}
                        <em> (showing {bodyData.length} of {totalResults?.toLocaleString()})</em>
                    </small>
                </div>
                <div className="grid-4 total-records">
                    {(totalChecked && totalChecked > 0) ?
                        <small data-testid="checked-rows">(Checked: {totalChecked?.toLocaleString()}) </small> : null
                    }
                </div>
            </div>
            <div className="index-header">
                {headerData.map((headerItem: TableHeaderDataProps) => (
                    <TableHeaderCell key={headerItem.id}
                        sortIndex={sortIndex}
                        activeColumn={activeColumn}
                        item={headerItem} />
                ))}
            </div>
            <div className={"main-table-content " + (isFiltering ? "filtering" : "")}>
                {
                    bodyData.length > 0 ?
                        bodyData.map((item: JSX.Element) => (
                            <React.Fragment key={item.key}>
                                {item}
                            </React.Fragment>
                        ))
                        :
                        message ?
                            <span>{message}</span>
                            :
                            <Loader loadingText="Loading data ..." spinnerColor="#000" isKraken={true} />
                }
            </div>

        </div>
    );
};

export default Table;